import { IMatchComment } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpMatchCommentsSubscription } from './typeguards';
import { CreateLmpMatchChangeInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpMatchCommentsSubscription } from '../types';
import { isLive, toOptionalString, toComment, MatchStatusType } from '../../../utils/match';
import { IMatchCommentsSubscription } from '../types';


export default (obj: LmpMatchCommentsSubscription): IMatchCommentsSubscription => {
  if (isValidLmpMatchCommentsSubscription(obj)) {
    CreateLmpMatchChangeInputSchema().parse(obj.data.onUpdateMatchCommentsByMatchIdAndPage, { reportInput: true });
    const matchComments = obj.data.onUpdateMatchCommentsByMatchIdAndPage;
    const comments = matchComments.comments
      ?.map(toComment)
      .filter((comment): comment is IMatchComment => Boolean(comment));

    

    const payload: IMatchCommentsSubscription = {
      comments,
      firstCommentDate: matchComments.firstCommentDate ?? '',
      lastCommentDate: matchComments.lastCommentDate ?? '',
      matchStatus: matchComments.matchStatus ?? '',
      isLive: isLive(matchComments.matchStatus as MatchStatusType),
      nextLink: toOptionalString(matchComments.pagination?.nextLink),
      prevLink: toOptionalString(matchComments.pagination?.prevLink),
      newPostsCount: undefined, 
      updatesBadge: undefined, 
    };

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpMatchCommentsSubscription object',
      data: obj,
    });
  }
};
